import { render } from "./VerDetalleImportacion.vue?vue&type=template&id=3cacdeca"
import script from "./VerDetalleImportacion.vue?vue&type=script&lang=js"
export * from "./VerDetalleImportacion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__